var render = function render(){var _vm=this,_c=_vm._self._c;return _c('UploadImage',{attrs:{"url":_vm.uploadUrl,"src":_vm.team.logo_url,"width":_vm.size,"height":_vm.size},on:{"success":function($event){return _vm.$emit('success')}}})
}
var staticRenderFns = []

export { render, staticRenderFns }